var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Dependencies } from '~/core/decorator';
import { State } from 'vuex-class';
import { Emit, Component } from 'vue-property-decorator';
import FileUpload from '~/components/common/file-upload.vue';
import { DataImportExcelInfoService } from '~/services/dataimp-service/data-import-excel-info.service';
var CaseExcelImport = /** @class */ (function (_super) {
    __extends(CaseExcelImport, _super);
    function CaseExcelImport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.importModel = {
            id: '',
            delegationDate: '',
            closeDate: '',
            fileId: '',
            templateId: '',
            memo: '',
            companyCode: '',
            principalId: '',
            principalName: '',
            recoverWay: 0,
            updateType: 0,
        };
        _this.templateList = [];
        _this.rules = {
            principalId: [{ required: true, message: '请选择委托方' }],
            templateId: [{ required: true, message: '请选择模板名称' }],
            updateType: [{ required: true }],
        };
        _this.fileList = [];
        _this.updateTypeList = [{ updateTypeName: "仅更新数据", updateType: 0 }, { updateTypeName: "更新并回收", updateType: 1 }];
        return _this;
    }
    CaseExcelImport.prototype.emitClose = function () {
        var upload = this.$refs['upload_case_import'];
        upload.reset();
        var dataform = this.$refs['form'];
        dataform.resetFields();
    };
    CaseExcelImport.prototype.emitSuccess = function () {
        this.$message.success('案件正在后台导入,请等待数据刷新');
        this.emitClose();
    };
    // 获取模板
    CaseExcelImport.prototype.getTemplate = function () {
        var _this = this;
        this.importModel.templateId = '';
        this.importExcelService.findTempletByPrincipalId({
            principalId: this.importModel.principalId,
        }).subscribe(function (data) {
            _this.templateList = data;
        });
    };
    CaseExcelImport.prototype.submit = function () {
        var _this = this;
        if (this.fileList.length === 0) {
            this.$message('请上传导入文件');
            return;
        }
        // 存储文件ID
        this.importModel.fileId = this.fileList[0].response.id;
        // 委托方名称
        var principal = this.principalList.content.find(function (v) { return v.id === _this.importModel.principalId; });
        this.importModel.principalName = principal ? principal.name : '';
        var dataForm = this.$refs['form'];
        dataForm.validate(function (valid) {
            if (!valid)
                return;
            _this.importExcelService.importExcelData(_this.importModel).subscribe(_this.emitSuccess);
        });
    };
    __decorate([
        State
    ], CaseExcelImport.prototype, "principalList", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CaseExcelImport.prototype, "importExcelService", void 0);
    __decorate([
        Emit("close")
    ], CaseExcelImport.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], CaseExcelImport.prototype, "emitSuccess", null);
    CaseExcelImport = __decorate([
        Component({
            name: "case-excel-import",
            components: {
                FileUpload: FileUpload
            }
        })
    ], CaseExcelImport);
    return CaseExcelImport;
}(Vue));
export default CaseExcelImport;
